var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommendedBrandsForCategory container"},[_c('SectionContainer',{attrs:{"title":_vm.data.title}},[_c('div',{staticClass:"recommendedBrandsForCategory__content"},[_c('SliderLogotypes',{attrs:{"items":_vm.items}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }